// getter
export const GETTERS_LIST_EMAIL_TEMPLATES = "GETTERS_LIST_EMAIL_TEMPLATES";
export const GETTERS_EMAIL_TEMPLATE_DETAIL = "GETTERS_EMAIL_TEMPLATE_DETAIL";
export const GETTERS_EMAIL_TEMPLATE_PAGINATION =
  "GETTERS_EMAIL_TEMPLATE_PAGINATION";

// action
export const ACTION_GET_EMAIL_TEMPLATE_LIST = "ACTION_GET_EMAIL_TEMPLATE_LIST";
export const ACTION_GET_ALL_EMAIL_TEMPLATE = "ACTION_GET_ALL_EMAIL_TEMPLATE";
export const ACTION_ADD_EMAIL_TEMPLATE = "ACTION_ADD_EMAIL_TEMPLATE";
export const ACTION_EDIT_EMAIL_TEMPLATE = "ACTION_EDIT_EMAIL_TEMPLATE";
export const ACTION_GET_EMAIL_TEMPLATE_DETAIL =
  "ACTION_GET_EMAIL_TEMPLATE_DETAIL";
export const ACTION_SET_EMPTY_EMAIL_TEMPLATE =
  "ACTION_SET_EMPTY_EMAIL_TEMPLATE";

// mutation
export const MUTATION_SET_EMAIL_TEMPLATE_LIST =
  "MUTATION_SET_EMAIL_TEMPLATE_LIST";
export const MUTATION_SET_EMAIL_TEMPLATE = "MUTATION_SET_EMAIL_TEMPLATE";



// WEBPACK FOOTER //
// ./src/store/modules/email_template/constants.js